// removed by extract-text-webpack-plugin
module.exports = {"Header":"_1CAkA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Headers/SearchResultHeader/SearchResultHeader.scss
// module id = 716
// module chunks = 0